import React from 'react';
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import Fitting1ExportContainer from '../containers/Fitting1ExportContainer.jsx';
import Fitting1EditSettingsContainer from '../containers/Fitting1EditSettingsContainer.jsx';
import Fitting1OrdererUploadContainer from '../containers/Fitting1OrdererUploadContainer.jsx';
import Fitting1AppCheckContainer from '../containers/Fitting1AppCheckContainer.jsx';

import DropDownInput from './common/DropDownInput.jsx';

export default class Fitting1Component extends React.Component {

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    this.props.clearFitting1Data();
    this.props.findAllOrderIds();
    if (this.props.eventKey === 0) {
    } else if (this.props.eventKey === 1) {
      if (this.props.orderId) {
        this.props.findOrderDetailBespokeList({ orderId: this.props.orderId });
      }
    } else if (this.props.eventKey === 3) {
      if (this.props.orderId) {
        this.props.findOrderAppCheckList({ orderId: this.props.orderId });
        this.props.changeShowAppCheckDiv('hidden');
      }
    }
  }

  handleSelect(key) {
    this.props.clearFitting1Data();
    this.props.changeEventKey(key);
    if (key === 0) {
    } else if (key === 1) {
      if (this.props.orderId) {
        this.props.findOrderDetailBespokeList({ orderId: this.props.orderId });
      }
    } else if (key === 3) {
      if (this.props.orderId) {
        this.props.findOrderAppCheckList({ orderId: this.props.orderId });
        this.props.changeShowAppCheckDiv('hidden');
      }
    }
  }

  render() {
    return (
      <div>
        <h4>套量App管理</h4>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={6} sm={3} md={3}>
            <DropDownInput id="orderId"
              label="訂單編號"
              options={this.props.allOrderIds.map((value, key) => ({ label: value, value: value })).toJS()}
              selected={[{ label: this.props.orderId, value: this.props.orderId }]}
              onChange={(id, value, label) => {
                this.props.clearFitting1Data();
                this.props.changeOrderId({ orderId: value });
                if (this.props.eventKey === 0) {
                } else if (this.props.eventKey === 1) {
                  this.props.findOrderDetailBespokeList({ orderId: value });
                } else if (this.props.eventKey === 3) {
                  this.props.findOrderAppCheckList({ orderId: value });
                  this.props.changeShowAppCheckDiv('hidden');
                }
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={12}>
            <Tabs id="editTab" defaultActiveKey={this.props.eventKey} animation={false} onSelect={this.handleSelect}>
              <Tab eventKey={3} title="App開啟設定">
                <Fitting1AppCheckContainer />
              </Tab>
              <Tab eventKey={2} title="匯入訂購人資料">
                <Fitting1OrdererUploadContainer />
              </Tab>
              <Tab eventKey={0} title="匯出App資料">
                <Fitting1ExportContainer />
              </Tab>
              <Tab eventKey={1} title="參數設定">
                <Fitting1EditSettingsContainer />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/Fitting1Component.jsx